<template>
	<div></div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
	name: "subCommon",
	methods: {
		...mapMutations(["SET_MICROROUTER"]),
	},
	// 路由守卫
	beforeRouteEnter(to, from, next) {
		/**
		 *  当子应用跳转不同的子应用时，当路由跳转后，再进行拦截，跳转对应子应用的子路由。(解决跳转异步问题)
		 * */
		next((vm) => {
			// console.log(123,123, vm.$route.params);
      if(vm.$route.params.module) {
        let m2 = vm.$route.params;
        vm.SET_MICROROUTER(m2);
      }
		});
	},
};
</script>



// WEBPACK FOOTER //
// src/micro-app/component/subCommon.vue